export default {
  'seivice.orderResponse': 'Order response',
  'seivice.material': 'Material',
  'seivice.warehouse': 'Warehouse',
  'seivice.profAtersalesTeam': 'Professional after-sales team'
}
